import React from 'react'
import ModalActionButton from '../../elements/ModalActionButton';
import TextField from '../../elements/form/TextField';
import { authHeader, baseUrl } from '../../../utils';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { SET_SUCCESS, ERROR } from '../../../store/types';

const CreateEditEmergencyContact = ({type, staff, close, reload}) => {
    const dispatch = useDispatch()
    const [processing, setProcessing] = React.useState(false)
    const [contact, setContact] = React.useState({})

    const [validationErrors, setValidationErrors] = React.useState({})
    const validateForm = () => {
        let errors = {}

        if(!contact.name || contact.name === '') {
            errors.name = true
        }

        if(!contact.phone || contact.phone === '') {
            errors.phone = true
        }

        if(!contact.email || contact.email === '') {
            errors.email = true
        }

        if(!contact.address || contact.address === '') {
            errors.address = true
        }

        setValidationErrors(errors)

        return errors
    }

    const updateAddress = (field, value) => {
        setContact({...contact, ...{address: {...contact.address, ...{[field]: value}}}})
    }

    const pushUpdate = async () => {
        const errors = validateForm()
        if(Object.keys(errors).length > 0) return

        const payload = {
            [type === 'emergency' ? 'emergencyContact' : 'nextOfKin']: {
                name: contact.name,
                phone: contact.phone,
                email: contact.email,
                address: `${contact.address?.address || ''}, ${contact.address?.city || ''}, ${contact.address?.state || ''}`,
            }
        }

        const headers = { 'Content-Type': 'application/json', ...authHeader() }

        try {
            setProcessing(true) 
            await axios.patch(`${baseUrl}/user/profile/staff`, payload, { headers })
            setProcessing(false)
            dispatch({
                type: SET_SUCCESS,
                payload: "Personal information updated successfully"
            })
            reload()
            close()
        } catch (error) {
            console.error(error)
            dispatch({
                type: ERROR,
                error
            })
            setProcessing(false)    
        }
    }
    
    return (
        <div className='w-full'>
            <div className='mt-3 w-full'>
                <TextField
                    inputLabel="Full name" 
                    inputPlaceholder="Contact full name" 
                    fieldId="full-name" 
                    inputType="text" 
                    disabled={false}
                    requiredField={true}
                    preloadValue={contact.name || ''}
                    hasError={validationErrors.name} 
                    returnFieldValue={(value)=>{setContact({...contact, ...{name: value}})}}
                />
            </div>
            <div className="w-full flex items-start justify-between gap-x-3">
                <div className='mt-3 w-full'>
                    <TextField
                        inputLabel="Email" 
                        inputPlaceholder="Contact email address" 
                        fieldId="email" 
                        inputType="email" 
                        hasError={validationErrors.email} 
                        requiredField={true}
                        preloadValue={contact.email || ''}
                        returnFieldValue={(value)=>{setContact({...contact, ...{email: value}})}}
                    />
                </div>

                <div className='mt-3 w-full'>
                    <TextField
                        inputLabel="Phone number" 
                        inputPlaceholder="Contact phone number" 
                        fieldId="phone" 
                        inputType="text" 
                        hasError={validationErrors.phone} 
                        requiredField={true}
                        preloadValue={contact.phone || ''}
                        returnFieldValue={(value)=>{setContact({...contact, ...{phone: value}})}}
                    />
                </div>
            </div>

            <div className='mt-3 w-full'>
                <TextField
                    inputLabel="Address" 
                    fieldId="address"
                    inputType="text" 
                    requiredField={true}
                    preloadValue={contact.address?.address || ''}
                    hasError={validationErrors['address-address']} 
                    inputPlaceholder={`Contact physical address`}
                    returnFieldValue={(value)=>{updateAddress('address', value)}}
                />
            </div>
            <div className='w-full flex items-start justify-between gap-x-3'>
                <div className='mt-3 w-full'>
                    <TextField
                        inputLabel="City" 
                        fieldId="address-city" 
                        inputType="text" 
                        requiredField={true}
                        preloadValue={contact.address?.city || ''}
                        hasError={validationErrors['address-city']} 
                        inputPlaceholder={`City or LGA (eg: Makurdi)`}
                        returnFieldValue={(value)=>{updateAddress('city', value)}}
                    />
                </div>
                <div className='mt-3 w-full'>
                    <TextField
                        inputLabel="State" 
                        fieldId="address-state" 
                        inputType="text" 
                        requiredField={true}
                        preloadValue={contact.address?.state || ''}
                        hasError={validationErrors['address-state']} 
                        inputPlaceholder={`Address state (eg: Benue)`}
                        returnFieldValue={(value)=>{updateAddress('state', value)}}
                    />
                </div>
            </div>

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Update ${type === 'emergency' ? 'Emergency Contact' : 'Next of Kin'}`}
                    buttonAction={()=>{pushUpdate()}}
                    processing={processing}
                />

                <button
                    type="button"
                    className="inline-flex font-space-grotesk justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary/40 focus:outline-none"
                    onClick={()=>{close()}}
                >
                    Close
                </button>
                
            </div>
        </div>
  )
}

export default CreateEditEmergencyContact